import apiMachines from '@services/api/machines'
import analytics from '@store/modules/machines/analytics'

export default {
  namespaced: true,
  modules: {
    analytics,
  },
  actions: {
    getPanel(_, payload) {
      return apiMachines.panel(this.$http, payload)
    },
  },
}
